import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { WebUser } from "@robe/core-types/web";

export const getLoggedInWebUser = (core: XcoreCore): BaseApiRequest<WebUser | null> =>
  core
    .fetch("/api/user/logged")
    .then((res) => res.json())
    .catch((_) => null);
